import { render, staticRenderFns } from "./tianBaoA.vue?vue&type=template&id=e388d72a&scoped=true&"
import script from "./tianBaoA.vue?vue&type=script&lang=js&"
export * from "./tianBaoA.vue?vue&type=script&lang=js&"
import style0 from "./tianBaoA.vue?vue&type=style&index=0&id=e388d72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e388d72a",
  null
  
)

export default component.exports